import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { titleCaseCompanyName } from '@nk/utils-lib';

@Pipe({
  standalone: true,
  name: 'prettyCompanyName',
})
@Injectable()
export class PrettyCompanyNamePipe implements PipeTransform {
  public transform(value: string | null): string | null {
    return titleCaseCompanyName(value);
  }
}
